import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'saldo-iniziale';
export const ENTITY_PLURAL = 'saldi iniziali';

export const gridColumns: EntityListField[] = [
  // {
  //   elementLabel: 'Ente',
  //   filterType: FilterType.enum,
  //   fieldType: FieldType.enum,
  //   field: 'ente.descrizione',
  //   entityName: 'ente',
  // },
  {
    elementLabel: 'Codice Piano dei Conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.codice',
  },
  {
    elementLabel: 'Piano dei Conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.descrizione',
    entityName: 'pianoConti',
  },
  {
    elementLabel: 'Saldo Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoDare',
    sortable: true,
  },
  {
    elementLabel: 'Saldo Avere',
    filterType: FilterType.number,
    contentAlignment: ContentAlignmentEnum.Right,
    fieldType: FieldType.currency,
    field: 'saldoAvere',
    sortable: true,
  },
  {
    elementLabel: 'Esercizio',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'esercizio',
    initialHideColumn: true,
    exportHideColumn: false,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
